<template>
    <div class="navbarMainWrapper" >
        <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="container-fluid">
            <a class="navbar-brand me-auto" href=".">
                <img src="@/assets/img/logo.svg" alt="">
            </a>
        
            <button 
                data-clickaway="menu"
                @click.prevent="$emit('update:showmenu', !showmenu)"
                class="navbar-toggler " 
                type="button" 
                aria-controls="navbarSupportedContent" 
                aria-expanded="false" 
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
        
            
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto">
                </ul>
                
                <ul class="navbar-nav">

                    <template v-for="menu in menus">
                        <template v-if="menu.route == 'ordersubscription' ">
                             <li
                                v-if="islogin" 
                                :key="menu.route" class="nav-item">
                                <a 
                                    @click.prevent="$router.push({name : menu.route})"
                                    :class="['nav-link', {'active' : $route.name == menu.route}]" 
                                    aria-current="page" 
                                    href="#">{{menu.name}}</a>
                            </li>
                        </template>

                        <template v-else>
                            <li 
                                :key="menu.route" 
                                :class="['nav-item', {'startOrderBtn' : menu.route == 'product'}]">
                                
                                <template v-if="menu.route == 'product'">
                                     <a 
                                        @click.prevent="ordernow('ordersubscription')"
                                        :class="['nav-link', {'active' : ['product', 'editsubscription'].includes($route.name)}]" 
                                        aria-current="page" 
                                        href="#">

                                            <template v-if="hassubscription">
                                                {{menu.allias}}
                                            </template>

                                            <template v-else>
                                                {{menu.name}}
                                            </template>
                                            
                                        </a>
                                </template>

                                <template v-else-if="menu.route == 'orderforevent'">
                                    <a 
                                        @click.prevent="ordernow('orderforevent')"
                                        :class="['nav-link', {'active' : ['orderforevent'].includes($route.name)}]" 
                                        aria-current="page" 
                                        href="#">{{menu.name}}</a>
                                </template>

                                <template v-else>
                                    <a 
                                        @click.prevent="$router.push({name : menu.route})"
                                        :class="['nav-link', {'active' :  $route.name == menu.route}]" 
                                        aria-current="page" 
                                        href="#">{{menu.name}}</a>
                                </template>

                            </li>
                        </template>

                    </template>
            
                    <li class="nav-item">
                        <template v-if="islogin">
                            <a 
                                @click.prevent="logout"
                                class="nav-link" href="#">Logout</a>
                        </template>

                        <template v-else>
                            <a 
                                @click.prevent="$router.push({name : 'login'})"
                                class="nav-link" href="#">Login</a>
                        </template>
                    </li>
                   
                </ul>
        
                <!-- <button 
                    @click.prevent="ordernow('ordersubscription')"
                    class="btn btn-outline-primary startOrderBtn" 
                    type="button">Start Order</button> -->
        
            </div>
        
        
            </div>
        </nav>
        </div>
    </div>

</template>

<script>

/**
 * Declerations
 */

// Helper
import Helper from '@/helpers/helper'

// plugins
import axios from 'axios';

export default {
    props : {
        showmenu : {
            type : Boolean,
            default : () => {
                return false
            }
        }
    },
    computed : {
        /**
         * Check if user has subscriptions
         */
        hassubscription () {
            const [sub] = this.$store.state.subscriptions;
            return sub ? true : false;
        },
        /**
         * Navgiation menus
         */
        menus () {
            return this.$store.state.menus
        },
        /**
         * Login state]
         * Login checker is in navguad.js
         */
        islogin : {
            get() {
                return this.$store.state.islogin
            },
            set(status) {
                this.$store.commit('updateloginstatus', status)
            }
        }
    },
    methods : {
        /**
         * Logout functin
         * delete cookie and redirect to home
         */
        async logout() {
            await Helper.deleteCookie('holeswebtoken');
            await axios.post('/logout');
            this.$store.commit('updateSubscriptions', []);
            this.islogin = false;
            if(this.$route.name != 'home') {
                this.$router.push({name : 'home'});
            }
        },
        /**
         * Function that will determine with type of order
         * and check if user is loggedin
         * @param {String} type = route name
         */
        ordernow(type) {
            let route = type;

            // check order type subscription or event
            const issubscription = type == 'orderforevent' ? false : true;

            /**
             * if subscription check if user have susbscription of none redirect to order box flavors selection
             * if does have subscription it should be redirect to edit subscription box
             */
            if(issubscription) {
                route =  this.hassubscription ? 'editsubscription' : 'product';
            }  

            this.$router.push({name : this.islogin ? route : 'login'}).catch(err => console.log(err));
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/global/_mixins.scss';

.navbarMainWrapper {
    @include screen-up(md) {
        padding-left : 15px;
        padding-right : 15px;
    }

    .navbar {
        padding-left : 0;
        padding-right: 0;

        .navbar-brand {
            margin-left : 0;
            margin-right: auto;
        }

        .container-fluid {
            padding-left : 0;
            padding-right: 0;
        }
    }
}
</style>